/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { omit } from 'lodash'
import CardWidget, { Colors } from '../../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../../components/skeletons/CardWidgetSkeleton'
import { PharmaciesDetailsFiltersContext } from '../../../../../context/PharmaciesDetailsFiltersContext'
import { formatDateTimeYear } from '../../../../../utils/Helpers'

const GET_PAYMENT_VALIDTY_END = gql`
  query PaymentValidityEnd($filters: NewOrderFilter) {
    pharmaciesAggs(
      size: 0,
      filters: $filters,
      aggs: { VencimentoContrato: { terms: { field: "pharmacyValidityEnd" } } }
    ) {
      aggregations
    }
  }
`

const PaymentValidityEnd = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_PAYMENT_VALIDTY_END,
    {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { orderCreatedAt: filters.createdAt, ...omit(filters, 'createdAt') }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  const date = formatDateTimeYear(
    data.pharmaciesAggs.aggregations.VencimentoContrato?.buckets[0]
      ?.key_as_string
  )

  const contractValidity = date || '-- / -- / ----'

  return (
    <CardWidget
      title="Vencimento do contrato"
      number={contractValidity!}
      color={Colors.green}
    />
  )
}

export default PaymentValidityEnd
